const COUNTRY_CODE = '55';
const LANDLINE_DIGITS = 10;
const MOBILE_DIGITS = 11;
const AREA_CODE_DIGITS = 2;

/* Brazilian area codes run 11 to 99, and a mobile number carries a leading 9 after
   them. Both checks exist to stop a random eleven-digit UTM value — an order id, a
   timestamp — from being prefilled into the field as if it were the lead's WhatsApp. */
const MIN_AREA_CODE = 11;

export const normalizePhone = (raw: string): string => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length > MOBILE_DIGITS && digits.startsWith(COUNTRY_CODE)) {
    return digits.slice(COUNTRY_CODE.length);
  }
  return digits;
};

export const isValidPhone = (raw: string): boolean => {
  const digits = normalizePhone(raw);
  if (digits.length !== LANDLINE_DIGITS && digits.length !== MOBILE_DIGITS) {
    return false;
  }
  if (Number(digits.slice(0, AREA_CODE_DIGITS)) < MIN_AREA_CODE) {
    return false;
  }
  return digits.length === LANDLINE_DIGITS || digits[AREA_CODE_DIGITS] === '9';
};

export const formatPhone = (raw: string): string => {
  const digits = normalizePhone(raw).slice(0, MOBILE_DIGITS);
  if (digits.length <= AREA_CODE_DIGITS) {
    return digits === '' ? '' : `(${digits}`;
  }
  const area = digits.slice(0, AREA_CODE_DIGITS);
  const rest = digits.slice(AREA_CODE_DIGITS);
  const splitAt = rest.length > 8 ? 5 : 4;
  if (rest.length <= splitAt) {
    return `(${area}) ${rest}`;
  }
  return `(${area}) ${rest.slice(0, splitAt)}-${rest.slice(splitAt)}`;
};

const UTM_PREFIX = 'utm_';
const PHONE_NAMES = /phone|telefone|whatsapp|celular|fone/i;

/* The bot can hand the lead's number over in the link, and typing it again is friction
   at exactly the point the page is asking for a favour. Su fixed only utm_source and
   utm_medium, so the name is not agreed: prefer a parameter that names itself a phone,
   and fall back to any utm value shaped like a Brazilian number. */
export const phoneFromParams = (search: string): string | null => {
  let fallbackNumber: string | null = null;
  for (const [rawKey, value] of new URLSearchParams(search)) {
    const key = rawKey.toLowerCase();
    if (!key.startsWith(UTM_PREFIX) || !isValidPhone(value)) {
      continue;
    }
    if (PHONE_NAMES.test(key)) {
      return normalizePhone(value);
    }
    fallbackNumber = fallbackNumber ?? normalizePhone(value);
  }
  return fallbackNumber;
};
